import React from 'react';
import {
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  thematicBreakPlugin,
  markdownShortcutPlugin,
  MDXEditor,
  toolbarPlugin,
  linkPlugin,
  linkDialogPlugin,
  tablePlugin,
  frontmatterPlugin,
  codeBlockPlugin,
  codeMirrorPlugin,
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CodeToggle,
  CreateLink,
  InsertCodeBlock,
  InsertTable,
  InsertThematicBreak,
  ListsToggle,
  StrikeThroughSupSubToggles,
  UndoRedo,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
} from '@mdxeditor/editor';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import '@mdxeditor/editor/style.css';

const ALL_PLUGINS = [
  toolbarPlugin({
    toolbarContents: () => (
      <>
        <BlockTypeSelect />
        <BoldItalicUnderlineToggles />
        <CodeToggle />
        <CreateLink />
        <InsertCodeBlock />
        <InsertTable />
        <InsertThematicBreak />
        <ListsToggle />
        <StrikeThroughSupSubToggles />
        <UndoRedo />
      </>
    ),
  }),
  listsPlugin(),
  quotePlugin(),
  headingsPlugin({}),
  linkPlugin(),
  linkDialogPlugin(),
  tablePlugin(),
  thematicBreakPlugin(),
  frontmatterPlugin(),
  codeBlockPlugin({ defaultCodeBlockLanguage: '' }),
  codeMirrorPlugin({
    codeBlockLanguages: {
      js: 'JavaScript',
      css: 'CSS',
      txt: 'Plain Text',
      tsx: 'TypeScript',
      '': 'Unspecified',
    },
  }),
  markdownShortcutPlugin(),
];

interface Props {
  markdown: string;
  onChange: (val: string) => void;
}

function MDXEditorWrapper({ markdown, onChange }: Props) {
  return (
    <MDXEditor plugins={ALL_PLUGINS} onChange={onChange} markdown={markdown} />
  );
}

export default MDXEditorWrapper;
